export const PAGES_LINKS = {
  'stocks': '/category/akcii',
  'news': '/category/novosti',
  'articles': '/category/stati',
  'competitors': '/company-allukraine',
};
